/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const UrlColumnFormatter = (cellContent, row, rowIndex) => {
  const { url } = row;
  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {url ? url : "-"}
      </div>
      <> </>
    </>
  );
};
